// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import { Dialog } from 'vant'
import axios from 'axios'
import 'vant/lib/index.css'
import Api from './api/Api'
import tool from './assets/js/tool'
import wechat from './assets/js/wechat'
Vue.use(Vant)

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$Api = Api
Vue.prototype.$tool = tool
Vue.prototype.$wechat = wechat
Vue.prototype.$dialog=Dialog
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js